import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import { localizeDate } from '@/utils/date';
import debounce from 'lodash/debounce';
import listMixin from '../../listMixin';
const defaultItemsPerPage = 10;
export default {
  name: 'NiotaClassicDevicesAddItemSelector',
  mixins: [listMixin],
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: () => ({})
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: ''
    },
    fireflyOriginatorsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'start'
      }, {
        sortable: false
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.table.name'),
        value: 'title',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.form.description'),
        value: 'title',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt',
        align: 'start'
      }],
      tableOptions: {
        sortBy: ['id'],
        sortDesc: [false],
        itemsPerPage: defaultItemsPerPage
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      accountIds: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    headers() {
      return this.getHeaders();
    }
  },
  watch: {
    accountIds: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList(true);
    }, 500)
  },
  methods: {
    rowStyle(item) {
      if (this.type === 'originator' && this.fireflyOriginatorsOnly) {
        if (item.datasource.type !== 'firefly' && item.datasource.type !== 'firefly_mqtt') {
          return 'opacity: 0.5';
        }
      }
      return '';
    },
    fetchList() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      let promise = undefined;
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      if (this.type === 'originator') {
        if (!this.accountIds.length) {
          promise = NiotaClassicApiService.originatorsFetch((this.searchItem || '').trim(), usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.originatorsFetchByAccount((this.searchItem || '').trim(), this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }
      if (this.type === 'application') {
        if (this.searchItem && this.searchItem.trim() !== '') {
          promise = NiotaClassicApiService.applicationsFind((this.searchItem || '').trim(), this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          if (!this.accountIds.length) {
            promise = NiotaClassicApiService.applicationsFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
          } else {
            promise = NiotaClassicApiService.applicationsFetchByAccount(this.accountIds, usedPage, usedItemsPerPage, sortItem, sortDirection);
          }
        }
      }
      promise.then(res => {
        if (this.type === 'originator') {
          this.list = res.data.originators;
          this.serverItemsLength = res.pagination.itemCount;
        }
        if (this.type === 'application') {
          if (res.data.applications) {
            this.list = res.data.applications;
          }
          if (res.data.application) {
            this.list = res.data.application;
          }
          this.serverItemsLength = res.pagination.itemCount;
        }
      }).catch(error => {
        if (this.type === 'originator') {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingOriginators'), 'error');
        }
        if (this.type === 'application') {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
        }
        console.error('Error fetching originators', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    localizeDate(item) {
      return localizeDate(item);
    },
    getHeaders() {
      if (this.type === 'originator') {
        this.tableHeaders.splice(2, 0, {
          text: this.$i18n_t('NiotaClassic.Devices.type'),
          value: 'createdAt',
          align: 'start'
        });
      }
      return this.tableHeaders;
    },
    handleClickRow(item) {
      if (this.type === 'originator' && this.fireflyOriginatorsOnly) {
        if (item.datasource.type !== 'firefly' && item.datasource.type !== 'firefly_mqtt') {
          return false;
        }
      }
      this.$emit('item-selected', item);
      this.resetFilter();
    },
    resetFilter() {
      this.accountIds = [];
    },
    goBack() {
      this.resetFilter();
      this.$emit('reset-application');
    },
    closeDialog() {
      this.$emit('close');
      this.resetFilter();
    }
  }
};